import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { Card } from '@/components/ui/card'
import { ProgressStepRow } from '@/components/extraction-progress-checklist'
import { buildMachineCharacteristicsExtractionSteps } from '../utils/buildMachineCharacteristicsExtractionSteps'
import type { MachineCharacteristicsExtractionTaskState } from '../utils/machineCharacteristicsExtractionTaskState'

export function MachineCharacteristicsExtractionProgress({
  state,
  className,
}: {
  state: MachineCharacteristicsExtractionTaskState
  className?: string
}) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const steps = useMemo(
    () => buildMachineCharacteristicsExtractionSteps(state, t),
    [state, t]
  )

  const headingLabel = t('onboarding.machineCharacteristicsExtraction.heading')

  return (
    <Card
      className={cn(
        'rounded-lg border bg-card px-4 py-3 text-sm shadow-sm',
        className
      )}
      role='region'
      aria-label={headingLabel}
    >
      <ul className='space-y-3' role='list'>
        {steps.map((step) => (
          <ProgressStepRow key={step.id} step={step} nested={false} />
        ))}
      </ul>
    </Card>
  )
}
